<template>
  <div style="height: 100%;margin: 0 30px;overflow: hidden">
    <div class="nothing-data" v-if="serviceAreaArr.length === 0"></div>
    <div v-else :style="{height: 'calc(100% - 10px)', margin: 'auto 0', zoom: 1 / this.golobleObject.zoom}" id="bar" ref="pie_area"></div>
  </div>
</template>

<script>
export default {
  name: 'rightTopService',
  data () {
    return {
      chartPie: null,
      serviceAreaArr: []
    }
  },
  created () {
  },
  mounted () {
    window.addEventListener('resize', () => {
      this.chartPie.resize()
    })
  },
  destroyed () {
  },
  methods: {
    getAreaPieData (arr) {
      this.serviceAreaArr = []
      if (arr === null || arr === '') {
        return
      }
      for (let i = 0; i < arr.length; i++) {
        let obj = {
          value: parseInt(arr[i].servicecount),
          name: arr[i].zonename
        }
        this.serviceAreaArr.push(obj)
      }
      // console.log('各区服务占比', arr, this.serviceAreaArr)
      let vm = this
      if (this.serviceAreaArr.length === 0) {
        return
      }
      // console.log('各区服务占比', arr, this.serviceAreaArr)
      setTimeout(() => {
        vm.getChartPieData()
      }, 300)
    },
    getChartPieData () {
      this.chartPie = this.$echarts.init(this.$refs.pie_area)
      this.chartPie.setOption({
        tooltip: {
          trigger: 'item'
        },
        legend: {
          type: 'scroll',
          orient: 'vertical',
          left: 'left',
          textStyle: {
            color: '#ffffff'
          }
        },
        series: [
          {
            name: '服务人数',
            type: 'pie',
            radius: '50%',
            center: ['65%', '50%'],
            data: this.serviceAreaArr,
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  // 平常不显示
                  color: '#fff',
                  textStyle: {
                    fontSize: '12'
                    // fontWeight: 'bold'
                  },
                  // formatter: '{b}\n{c} 人/{d}%'
                  formatter: '{b}\n{d}%'
                }
              }
            }
          }
        ]
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/monitoring/weiNingComponents/rightTopService.vue